import React from "react";
import { Link } from "react-router-dom";
import CategoryList from "../../components/Master/CategoryList";


const CategoryListPage = () => {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Category List</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Master</li>
          <li>Category List</li>
        </ul>
      </div>
      <CategoryList />
      {/* <CategoryList /> */}
    </>
  );
}
export default CategoryListPage;
